export { KeyAlt as default } from './KeyAlt';
